import React from 'react';
import PropTypes from 'prop-types';

const IFSC = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.47 8.41001V8.00001C21.466 7.82252 21.4147 7.6493 21.3216 7.49816C21.2284 7.34702 21.0967 7.2234 20.94 7.14001L12.44 2.79001C12.303 2.72289 12.1525 2.688 12 2.688C11.8475 2.688 11.697 2.72289 11.56 2.79001L3.06 7.17001C2.90755 7.25087 2.77862 7.3698 2.68575 7.51524C2.59287 7.66069 2.53922 7.82769 2.53 8.00001V8.38001C2.53 8.64522 2.63536 8.89958 2.82289 9.08711C3.01043 9.27465 3.26478 9.38001 3.53 9.38001H5V19.38H3.5C3.23478 19.38 2.98043 19.4854 2.79289 19.6729C2.60536 19.8604 2.5 20.1148 2.5 20.38C2.5 20.6452 2.60536 20.8996 2.79289 21.0871C2.98043 21.2746 3.23478 21.38 3.5 21.38H20.5C20.7652 21.38 21.0196 21.2746 21.2071 21.0871C21.3946 20.8996 21.5 20.6452 21.5 20.38C21.5 20.1148 21.3946 19.8604 21.2071 19.6729C21.0196 19.4854 20.7652 19.38 20.5 19.38H19V9.38001H20.5C20.7549 9.37247 20.9972 9.26785 21.1775 9.08755C21.3578 8.90725 21.4625 8.66488 21.47 8.41001ZM12 4.79001L17.19 7.44001H6.81L12 4.79001ZM7 9.38001H11V19.38H7V9.38001ZM17 19.38H13V9.38001H17V19.38Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

IFSC.propTypes = {
  fill: PropTypes.string,
};

export default IFSC;
